import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Callback = () => {
  const navigate = useNavigate();
  const { handleCallback } = useAuth();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Get the full URL and parse it
        const fullUrl = window.location.search;
        const params = new URLSearchParams(fullUrl);
        
        // Log the callback parameters for debugging
        const callbackParams = {
          code: params.get('code'),
          error: params.get('error'),
          errorDescription: params.get('error_description'),
          fullUrl
        };
        console.log('OAuth Callback Params:', callbackParams);

        // Check for errors in the callback
        if (callbackParams.error) {
          throw new Error(`OAuth Error: ${callbackParams.error} - ${callbackParams.errorDescription || 'No description provided'}`);
        }

        // Ensure we have a code
        if (!callbackParams.code) {
          throw new Error('No authorization code received');
        }

        // Exchange the code for tokens
        await handleCallback(callbackParams.code);
        
        // Redirect to home page on success
        navigate('/');
      } catch (error) {
        console.error('Callback Error:', error);
        // Redirect to login page with error
        navigate('/login', { 
          state: { 
            error: error.message || 'Authentication failed'
          }
        });
      }
    };

    handleOAuthCallback();
  }, [navigate, handleCallback]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Completing Authentication...</h2>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
      </div>
    </div>
  );
};

export default Callback; 